<template>
  <div style="margin: 0;padding: 0;">
    <el-header style="height: 45px;margin: 0;padding: 0;color: #ffffff;width: 100%;overflow: hidden;">
      <div style="width: 100%;min-height: 45px;max-height: 55px;">
        <div style="display: inline-block;margin-right: 20px;vertical-align: top;">
          <el-input v-model="serchat" placeholder="请输入客户名称" maxlength="30" style="width: 150px;"></el-input>
          <el-dropdown split-button type="primary" @command="commandEvent">
            <span v-html="dropdownTitle"></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="全部">全部</el-dropdown-item>
              <el-dropdown-item v-for="(item,index) in dropdownList" :key="index" :command="item.label">{{item.label}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="isAjax" plain>查询</el-button>
          &nbsp;&nbsp;&nbsp;<span>最后更新时间：<span v-html="end_time"></span></span>
        </div>
        <el-button type="success" size="small" style="float: right;" @click="tp" v-show="isTpShow">投屏<i class="el-icon-copy-document el-icon--right"></i></el-button>
      </div>
    </el-header>
    <el-container>
      <el-main>
        <div style="width: 100%;">
          <div id="myChart_platform" :style="divHeight">
          </div>
          <div id="myChart_brand" :style="divHeight">
          </div>
          <div id="myChart_model" :style="divHeight">
          </div>
        </div>
      </el-main>
      <el-footer>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  import PurplePassion from '@/assets/purplePassion.js'
  import apiController from '@/api/device'
  export default {
    name: 'device',
    data () {
      return {
        end_time:'',
        myChart_platform:null,
        myChart_brand:null,
        myChart_model:null,
        divHeight:{
          width: '50%', height: '315px',float:'left'
        },
        serchat:"",
        dropdownTitle:"请选择",
        dropdownList:[],
        isTpShow:true,
      }
    },
    methods: {
      tp(){
        window.open(location.href+"?t=1","_blank");
      },
      commandEvent(command) {
        this.dropdownTitle = command
      },
      addClass:async function(){
        await this.$axios.post('/data/addClass',{
          uid:""
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.dropdownList = response.data[0];
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      isAjax:async function(){
        const h = this.$createElement;
        this.$notify({
          title: '提示',
          message: h('i', { style: 'color: red'}, '该功能目前只兼容部分2.6.2版本。')
        });
        await apiController
          .getDevice({
            params:{
              drop:this.dropdownTitle,
              serchat:this.serchat,
            }
          })
          .then(res => {
            let platformRow = [], platformList = [], brandRow = [], brandmList = [], modelRow = [], modelList = []
            let { data, code } = res.data
            if (code === 'Success'){
              let _platform = data[0]
              let _brand = data[1]
              let _model = data[2]
              this.end_time = data[3]?data[3]:'暂无'
              for(let _p = 0;_p<_platform.length;_p++){
                if(_platform[_p]._id == 'unknown'){
                  _platform[_p]._id = '未知'
                }
                platformRow.push(_platform[_p]._id)
                platformList.push({ "name": _platform[_p]._id, "value": _platform[_p].count })
              }
              for(let _b = 0;_b<_brand.length;_b++){
                if(_brand[_b]._id == 'unknown'){
                  _brand[_b]._id = '未知'
                }
                brandRow.push(_brand[_b]._id)
                brandmList.push({ "name": _brand[_b]._id, "value": _brand[_b].count })
              }
              for(let _m = 0;_m<_model.length;_m++){
                if(_model[_m]._id == 'unknown'){
                  _model[_m]._id = '未知'
                }
                modelRow.push(_model[_m]._id)
                modelList.push({ "name": _model[_m]._id, "value": _model[_m].count })
              }
            }
            this.myChart_platform.hideLoading();
            this.myChart_platform.setOption(this.dataPie(platformRow,platformList,'设备系统'),true);
            this.myChart_brand.hideLoading();
            this.myChart_brand.setOption(this.dataPie(brandRow,brandmList,'设备品牌'),true);
            this.myChart_model.hideLoading();
            this.myChart_model.setOption(this.dataPie(modelRow, modelList, '设备型号(前15)'),true);
            this.divHeight.height = (window.innerHeight-58)/2+"px";
          })
          .catch((error) => {
            this.$message.error(JSON.stringify(error));
          })
      },
      //随机生成颜色
      handleColors(){
        //定义字符串变量colorValue存放可以构成十六进制颜色值的值
        var colorValue="0,1,2,3,4,5,6,7,8,9,a,b,c,d,e,f";
        //以","为分隔符，将colorValue字符串分割为字符数组["0","1",...,"f"]
        var colorArray = colorValue.split(",");
        var color="#";//定义一个存放十六进制颜色值的字符串变量，先将#存放进去
        //使用for循环语句生成剩余的六位十六进制值
        for(var i=0;i<6;i++){
          //colorArray[Math.floor(Math.random()*16)]随机取出
          // 由16个元素组成的colorArray的某一个值，然后将其加在color中，
          //字符串相加后，得出的仍是字符串
          color+=colorArray[Math.floor(Math.random()*16)];
        }
        return color;
      },
      dataPie(row,list,title){
        var _this = this
        return {
          title: {
            text: title,
            subtext: '',
            left: 'center'
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            type: 'scroll',
            orient: 'vertical',
            right: 10,
            top: 20,
            bottom: 20,
            data: row
          },
          series: [
            {
              name: title,
              type: 'pie',
              radius: '55%',
              center: ['40%', '50%'],
              data: list,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
      },
      GetUrlParms() {
        var args = new Object();
        var query = location.search.substring(1); //获取查询串
        var pairs = query.split("&"); //在逗号处断开
        for (var i = 0; i < pairs.length; i++) {
          var pos = pairs[i].indexOf('='); //查找name=value
          if (pos == -1) continue; //如果没有找到就跳过
          var argname = pairs[i].substring(0, pos); //提取name
          var value = pairs[i].substring(pos + 1); //提取value
          args[argname] = value; //存为属性
        }
        return args;

      }
    },
    mounted() {
      var args=this.GetUrlParms();
      var t = args["t"];
      if(t != null){
        if(t == 1){
          this.isTpShow = false;
        }
      }
      this.addClass();
      this.$echarts.registerTheme('purple-passion', PurplePassion)
      this.myChart_platform = this.$echarts.init(document.getElementById('myChart_platform'),'purple-passion')
      this.myChart_brand = this.$echarts.init(document.getElementById('myChart_brand'),'purple-passion')
      this.myChart_model = this.$echarts.init(document.getElementById('myChart_model'),'purple-passion')
      this.isAjax();
    },
    created () {

    },
    watch: {

    },
    beforeCreate () {

      document.querySelector('body').setAttribute('style', 'background-color:#5B5C6E')

    },
  }
</script>
<style scoped>
  .el-main{
    overflow: hidden;
    padding: 0 !important;
    margin: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/dataStatistics/device.vue